import { render, staticRenderFns } from "./StandardBottomNavigation.vue?vue&type=template&id=8c0819ce"
import script from "./StandardBottomNavigation.vue?vue&type=script&lang=js"
export * from "./StandardBottomNavigation.vue?vue&type=script&lang=js"
import style0 from "./StandardBottomNavigation.vue?vue&type=style&index=0&id=8c0819ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports